import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  updateProgressAddHighlight,
  updateProgressDeleteHighlight,
} from "../actions/progress";

/**
 * Manages text-highlight records persisted in the database via Redux.
 * Each record shape: { id, paragraphId, color, exact, prefix, suffix, createdAt }
 * @returns {{ highlights: object[], saveHighlight: function, deleteHighlight: function }}
 */
export function useHighlights() {
  const dispatch = useDispatch();
  const { id: courseId } = useParams();
  const highlights = useSelector((state) => state.ProgressReducer.highlights);

  const saveHighlight = useCallback(
    (record) => {
      const highlight = {
        ...record,
        id: crypto.randomUUID(),
        createdAt: Date.now(),
      };
      dispatch(updateProgressAddHighlight(courseId, highlight));
    },
    [dispatch, courseId],
  );

  const deleteHighlight = useCallback(
    (id) => {
      dispatch(updateProgressDeleteHighlight(courseId, id));
    },
    [dispatch, courseId],
  );

  return { highlights, saveHighlight, deleteHighlight };
}
